var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"21","viewBox":"0 0 24 21"}},[_c('path',{attrs:{"fill":"#F8F8F8","stroke":"#EEE","d":"M12 1.092L8.8 7.308l-7.105.989 5.139 4.8-1.219 6.81L12 16.69l6.385 3.217-1.219-6.81 5.139-4.8-7.104-.99L12 1.093z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }